import { MultiSelectWithAutoTransform } from "./MultiSelectWithAutoTransform";
export class MultiSelectWithInsert extends MultiSelectWithAutoTransform {
    constructor(element, options) {
        super(element, options);
        this.onRequestEnd = (args) => {
            if (args.type !== "create") {
                return;
            }
            const newValue = args.response[this.options.dataValueField];
            if (this.isVirtual) {
                this.dataSource.one("sync", () => {
                    this.value(this.value().concat([newValue]));
                    this.close();
                });
            }
            else {
                this.dataSource.read().then(() => {
                    this.value(this.value().concat([newValue]));
                    this.close();
                });
            }
        };
        this.doesUpdate = !!options && !!options.dataSource && !!options.dataSource.transport && !!options.dataSource.transport.create;
        this.jsonDataSource = this.doesUpdate && options.dataSource.transport.create.dataType.indexOf("json") >= 0;
        this.isVirtual = options.virtual !== false;
        if (this.doesUpdate) {
            this.dataSource.bind("requestEnd", this.onRequestEnd);
        }
        else {
            this.serverDataSource = this.dataSource;
            this.serverDataSource.fetch().then(() => {
                const localDataSource = new kendo.data.DataSource({ data: this.serverDataSource.data().slice(0) });
                localDataSource.read();
                this.setDataSource(localDataSource);
                this.refresh();
            });
        }
    }
    static mapParameterWithInsert(a) {
        const element = a.data("kendoMultiSelectWithInsert").input.val();
        return { text: element };
    }
    addItemClicked() {
        if (!this.options.dataValueField) {
            this.dataSource.data().push(this.input.val());
            this.value(this.value().concat([this.input.val()]));
            this.close();
            this.refresh();
        }
        else {
            const newItem = {};
            newItem[this.options.dataTextField] = this.input.val();
            if (this.doesUpdate) {
                newItem[this.options.dataValueField] = 0;
            }
            else {
                if (this.options.useTextAsValue === undefined || !this.options.useTextAsValue) {
                    newItem[this.options.dataValueField] = Math.random() * 100;
                }
                newItem[this.options.dataValueField] = this.input.val();
            }
            this.dataSource.add(newItem);
            this.dataSource.sync().then(() => {
                if (!this.doesUpdate) {
                    this.value(this.value().concat([newItem[this.options.dataValueField]]));
                    this.close();
                    this.refresh();
                }
            });
        }
    }
}
// Create an alias of the prototype (required by kendo.ui.plugin)
MultiSelectWithInsert.fn = MultiSelectWithInsert.prototype;
// Deep clone the widget default options
MultiSelectWithInsert.fn.options = $.extend(true, {}, kendo.ui.MultiSelect.fn.options);
// Specify the name of your Kendo UI widget. Used to create the corresponding jQuery plugin.
MultiSelectWithInsert.fn.options.name = "MultiSelectWithInsert";
// Create a jQuery plugin.
kendo.ui.plugin(MultiSelectWithInsert);
